var _circle, _rect, _mask, _rect2, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgDoorController4Inline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 20,
    r: 20,
    fill: "#F1F1F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 11,
    y: 13,
    width: 18,
    height: 14,
    rx: 1,
    fill: "#0F0449"
  })), _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "door-controller-4_inline_svg__a",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 7,
    height: 10,
    rx: 0.5
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 15,
    width: 7,
    height: 10,
    rx: 0.5,
    stroke: "#fff",
    strokeWidth: 3,
    mask: "url(#door-controller-4_inline_svg__a)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.758 15a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zM26.242 15a.75.75 0 01.75.75v3a.75.75 0 01-1.5 0v-3a.75.75 0 01.75-.75zM22.492 24.25a.75.75 0 01.75-.75h3a.75.75 0 010 1.5h-3a.75.75 0 01-.75-.75z",
    fill: "#fff"
  })));
}

export default SvgDoorController4Inline;